<template>
<div>
  <div>
  <div id="overview" class="text">
    <h4>OVERVIEW</h4>
    Welcome to PsychCloud, a template for designing, programming,
    and running Psychology experiments in the cloud!
    <br><br>
    <b>What is PsychCloud?</b>
    <ul>
      <li>PsychCloud is a framework - a stack of technologies - for
        running experiments online using Google's App Engine.</li>
      <li>PsychCloud is a set of code available on GitHub that gives
        examples of many different functions necessary for websites in general,
        and online psychology experiments in particular. None of this
        code is required – it is just provided as a way for you to get
          started to build your own experiment as an online app. </li>
      <li>PsychCloud is the website you are looking at.
        This is the same code that is posted on github. This website
        is designed for you to download from github, run on your own
        computer, and modify as you need.
        The best way to use this website is to simultaneously use the
        website and also look at the code for how the website works.</li>
    </ul>

    <b>What PsychCloud is not:</b>
    <ul>
      <li>PsychCloud is not a stand-alone application designed specifically
        for psychology studies (e.g., E-Prime, Inquisit, Presentation).
        It is a framework that can be used to make websites in general.</li>
      <li>PsychCloud is not a package (e.g., Psychtoolbox for Matlab, or
        PsychoPy for Python) of functions and classes for you to learn.
        All you have to learn to use PsychCloud are the standard technologies
        of the web.</li>
      <li>PsychCloud is not intneded as a replacement for online survey software
        (e.g., Qualtrics, SurveyMonkey) –it is intended for situation in which you
        need to build dynamic websites that are much more customizable.</li>
    </ul>

    <b>Want to get involved?</b>
    We welcome you to get in contact by email (rottman@pitt.edu or yiwenzhang@pitt.edu),
    or better yet, to request features and post solutions on
      <a>GitHub</a>!
    <br>
    <br>
    <p>We have conducted serveral smartphone-based/web-based online study using this framework!
      Check our papers:</p>
    <p><b>Zhang, Y.</b> & Rottman, B. M. (2023). Casual Learning with Delays Up to 21 Hours.
    <i>Psychonomic Bulletin & Review</i></p>
    <p><b>Zhang, Y.</b> & Rottman, B. M. (2023). Causal Learning with Interrupted Time Series Data.
    <i>Judgment and Decision Making</i></p>
  </div>
  <div id="stack" class="text">
    <h4>PsychCloud's STACK</h4>
    PsychCloud was largely inspried by
    <a href="http://shop.oreilly.com/product/9780596801601.do" target="_blank">
    Using Google App Engine</a> by <a href="http://www.dr-chuck.com/" target="_blank">
    Charles Severance</a>. While the book is somewhat dated, it serves as a superb and accessible
    introduction to web programming, suitable for beginners and those new to coding.'
    We strongly recommend familiarizing yourself with the concepts in this book to better
    understand PsychCloud. However, please note that the code examples in the book may
    be outdated, so it's advisable not to directly implement them, but rather use them
    as a learning tool before engaging with PsychCloud's codebase.
    <br>
    <br>
    PsychCloud employs the <a href="https://flask.palletsprojects.com/en/1.1.x/" target="_blank">
          Flask</a> framework for the backend,
          <a href="https://vuejs.org/v2/guide/" target="_blank">Vue.js</a> for the frontend,
    <a href="https://cloud.google.com/firestore" target="_blank"
          >Google Cloud Firestore </a> for database,
    and <a href="https://cloud.google.com/appengine/docs/standard/python3" target="_blank">
          Google App Engine</a> as its server platform. We provide a few resources below to help
    you build your first app using this stack framework.
        <ul>
          <li>A <a href="https://cloud.google.com/appengine/docs/standard/python3/building-app">
          tutorial</a> building a python 3 (flask) app on Google App Engine.
          </li>
          <li>A <a href='https://testdriven.io/blog/developing-a-single-page-app-with-flask-and-vuejs/'
          target="_blank">
          turtorial</a> about using Vue.js as the front-end in a python 3 (flask) app.</li>
          <li>Once you have your Flask-Vue app and want to deploy it to google app engine? Please
            check out this configuration
            <a href='https://github.com/Valmoz/gae-vue-flask-starter' target="_blank">
            template</a>.
          </li>
          <li>A <a href="https://firebase.google.com/docs/firestore/quickstart#python"
          >tutorial</a> for connecting Firestore database with a Python/Flask app.</li>
        </ul>
  </div>
<!-- <div id="run" class="text">
  <h4>GETTING UP AND RUNNING</h4>
  <ul>
  <li id="runLocal"><b>Running the app on your local computer</b>
    <ul>
      <li><b><a href='https://github.com/BenRottman/psychcloud' target="_blank">
      Download</a> the PsychCloud template from github.</b> You can download the
      template from github without using github for your own software development.
       However, if you plan on developing your own app, we high encourage you to
        use github to keep versions of your app as you make changes. If you are new,
         take a look at the <a href='https://guides.github.com/' target="_blank">
         GitHub Guides</a> especially the
        <a href='https://guides.github.com/activities/hello-world/' target="_blank">
         Hello World</a> introduction. Also, check out the all new
          <a href='https://desktop.github.com/' target="_blank">GitHub Desktop</a>
           application, so you can use github without using any code, and also check
            out the <a href='https://help.github.com/desktop/guides/' target="_blank">
             GitHub Desktop user guides</a>!
      </li>

      <li><b>Install and initialize <a href='https://cloud.google.com/sdk/docs' target="_blank">
      the Google Cloud SDK.</a></b> (For users new to programming, this is the
       <a href='https://www.macworld.co.uk/feature/mac-software/how-use-terminal-on-mac-3608274/' target="_blank">
       Terminal application</a>  on Mac, and the
      <a href='https://www.lifewire.com/command-prompt-2625840' target="_blank">Command Prompt
      </a> application for Windows.) Follow the
      <a href='https://cloud.google.com/appengine/docs/standard/python/download' target="_blank">
      instructions</a> to install the Google Cloud SDK. In particular, you must:
        <ul>
          <li>Install Python. Cloud SDK uses Python 2 by default, but will soon move to
             Python 3 so we recommended you install python 3.5-3.7 in your computer.</li>
          <li>Download and install the latest Cloud SDK version</li>
          <li>Run the following the line of code in the command line
            <pre>./google-cloud-sdk/bin/gcloud init</pre>
          </li>
        </ul>
      </li>
      <li><b>Create a Cloud project.</b> You have two ways to create a cloud project:
      <ul>
          <li>Option 1: run the line below in your terminal.
            <pre>gcloud projects create [YOUR_PROJECT_ID] --set-as-default</pre>
            Replace [YOUR_PROJECT_ID] with your project name, e.g. <code>PsychCloudExample</code>.
          </li>
          <li>Option 2: go to <a href='https://console.cloud.google.com/' target="_blank">
          Google Cloud Console</a> to create a new project.
          </li>
        </ul>
      </li>
      <li><b>Running a hello-world app.</b> Once you have downloaded the psychcloud template,
       put it into a folder somewhere you will want to keep it.
        <ul>
          <li>Create a virtual environment for running the app locally:
            <pre>python3 -m venv env</pre>
            <pre>source env/bin/activate</pre>
          </li>
          <li>Change to the directory to the hello-world app:
            <pre>cd [YOUR_PATH]/PsychCloud/hello_world</pre>
          </li>
          <li>Install dependencies
            <pre>pip3 install  -r requirements.txt</pre>
          </li>
          <li>Run your app
            <pre>python3 main.py</pre>
          </li>
          <li>If this is succesful, you will get a response like:
            <pre>* Serving Flask app "main" (lazy loading)
 * Environment: production
   WARNING: This is a development server. Do not use it in a production deployment.
   Use a production WSGI server instead.
 * Debug mode: on
 * Running on http://127.0.0.1:8080/ (Press CTRL+C to quit)
 * Restarting with stat
 * Debugger is active!
 * Debugger PIN: 146-486-153</pre></li>
          <li>Type <a href="http://localhost:8080" target="_blank">http://localhost:8080</a>
            into your browser. You will see a line: <code>Hey! This is PsychCloud</code>
          </li>
          <li>To stop the local server:
            <ul>
              <li>Mac: <code>Control-C</code></li>
              <li>PC: <code>Control-Break</code></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </li>
  <li><b>Deploy the app to goole app engine</b>. From the app folder, type in the command line:
  <pre>gcloud app deploy</pre>
  </li>
  <li id="session"><b>Set Up Sessions</b>. We recommended to use the session in flask.
  Here is a good <a href='https://www.tutorialspoint.com/flask/flask_sessions.htm' target="_blank">
  turtorial</a> from Flask. We highly recommended you to check this out.
    <ul>
      <li>Import sessions in your <code>main.py</code> and set <code>secret_key</code>
       of the application. What you need to do is to update the beginning part of
       <code>main.py</code> to:
        <pre>Import logging
from flask import Flask, render_template, session
app = Flask(__name__)
app.secret_key = 'any random string that only you know’</pre>
      </li>
    </ul>
  </li>
  <li><b id="debug">Debugging</b>
    <ul>
    <li><b>Errors in Python.</b>
      <ul>
        <li>If you used the command line interface, then errors in python and flask will
           show up in the terminal app (Mac) or the command prompt (Windows). If you have
            deployed the app to the Google App Engine. You can see errors in <a href='https://console.cloud.google.com/' target="_blank">
          Google Cloud Console</a></li>
        <li>You can write <code>print()</code> in python. When the app is running locally,
        you can see the output of <code>print()</code> in the terminal command line.</li>
        <li>You can write logs:
          <pre>logging.info('This is an info message')</pre>
          See <a href="https://cloud.google.com/appengine/docs/standard/python/logs/" target="_blank">
          this link</a> for more details.
        </li>
        <li>In the hello-world example, you will see <code>running hello-world app</code>
        in the command line interface when you go to <a href="http://localhost:8080" target="_blank">http://localhost:8080</a></li>
      </ul>
    </li>
    <li><b>Errors in Javascript.</b> Front-end errors show up in the browser. For example,
     in Chrome, go View->Developer->Javascript Console, or in Firefox, go
      Tools->Web Developer->Console.</li>
    <li>In javaScript, You can write
      <pre>console.log("Your text")</pre>
      It will also show in the browser's console.</li>
    </ul>
  </li>
  </ul>
  <div id="firestore" class="text">
    <h4><b>Use Cloud Firestore as Database</b></h4>
    <ul>
      <li>Create a cloud firestore in native mode
        <ul>
        <li>Go to <a href='https://console.cloud.google.com/' target="_blank">
          Google Cloud Console</a></li> and click the three bar in the upper left of the
           page and you will see a menu of google cloud products.
        <li>Click “Firestore” in STORAGE part and select NATIVE MODE and follow the
           instruction to create a database. </li>
        <li>If this is successful, you will see
           <code>“Your database is ready to go. Just add data.”</code></li>
        </ul>
      </li>
      <li>Add the following two line to your <code>requirements.txt</code>
        <pre>firebase-admin==2.13.0<br>google-cloud-firestore==0.29.0</pre>
      </li>
      <li>In your main.py, import firestore admin and credentials:
<pre>import firebase_admin
from firebase_admin import credentials
from firebase_admin import firestore

# Use the application default credentials
cred = credentials.ApplicationDefault()
firebase_admin.initialize_app(cred, {
  'projectId': [your project_id goes here],
})

db = firestore.client()</pre>
      </li>
      <li>Download and export credentials
        <ul>
          <li>Create service account key following the <a href='https://cloud.google.com/docs/authentication/getting-started' target="_blank">
          instruction</a>. You will download a JSON file on your computer.
          </li>
          <li>In your terminal, export the JSON file:
            <pre>export GOOGLE_APPLICATION_CREDENTIALS="/home/user/Downloads/[FILE_NAME].json"</pre>
          </li>
          <li>For more information, please check <a href='https://firebase.google.com/docs/firestore/quickstart' target="_blank">
          the firestore documentation</a></li>
        </ul>
      </li>
    </ul>
  </div>
  <div id="vue" class="text">
    <h4><b>Use Vue.js as the Front-end Framework</b></h4>
    This is completely optional. You can use
    <code>html+css+javastript</code> to build your front-end. The reason we use Vue.js is
     that it offers a lot of useful libraries and helps us focus on developing the main
      features of our website. Also, compared to React and Angular, Vue.js is more friendly
      to beginners.<br>
      <ul>
      <li>Install Vue CLI by running: <pre>$ npm install -g @vue/cli@3.7.0</pre></li>
      <li>Create a new folder for the Vue.js project in your app folder by running:
        <pre>$ vue create client</pre>
        Here <code>client</code> is the folder's name. You need to select a few settings
         for your new project. Below is what we selected:
         <pre>? Please pick a preset: Manually select features
? Check the features needed for your project: Babel, Router, Vuex, Linter
? Use history mode for router? (Requires proper server setup for index fallback
 in production) Yes
? Pick a linter / formatter config: Prettier
? Pick additional lint features: Lint on save
? Where do you prefer placing config for Babel, ESLint, etc.? In package.json
? Save this as a preset for future projects? (y/N) N</pre>
      If this is succesful, you will see something like:
<pre>🎉  Successfully created project client.
👉  Get started with the following commands:

 $ cd client
 $ npm run serve</pre>
      </li>
      <li>Create a new js file called <code>vue.config.js</code> and write:
      <pre>module.exports = {
  outputDir: '../dist',
  assetsDir: 'static',
  devServer: {
    port: 3000,
  },
};
</pre>
    </li>
    <li>Run Vue.js app locally. Then you can navigate to <code>client</code> folder
    and run your vue.js project locally by running these two lines:
<pre>cd client
npm run serve</pre>
      If this is successful, you will see:
      <pre>  App running at:
  - Local:   http://localhost:3000/
  - Network: http://192.168.0.106:3000/</pre>
    Type <a href="http://localhost:3000" target="_blank">http://localhost:3000</a>
    into your browser. You will see a welcome page from Vue. You can stop the local server
    by <code>Control-C</code> for Mac users and <code>Control-Break</code> for PC users.
      </li>
      <li>Build your Vue front-end. When you finish developing the front end, you can build
         the Vue project by running:
         <pre>npm run build</pre></li>
        If it is built succesful, you will see a <code>dist</code> folder in your app engine
        project folder(not the <code>client</code> folder). Your app engine folder should
        looks like:
<pre> test-hello-world-app
├── app.yaml
├── client
│   └── ...
├── dist
│   ├── index.html
│   └── static
│       ├── css
│       └── js
├── main.py
└── requirements.txt</pre>
      Now your vue front end has been complied as some <code>html css js</code> file and ready
      for deployment.
      <li>Connect the flask back end with vue.js.
        <ul>
        <li>In <code>main.py</code>, replace
       <code>app = Flask(__name__)</code> by the following lines:
      <pre>app = Flask(__name__,
            static_folder="./dist/static",
            template_folder="./dist")
app.config.from_object(__name__)</pre>
        Then, add a global variable <code>isDuggingVue</code>:
        <pre>isDuggingVue = True</pre>
        Then replace <code>def hello()</code>with:
        <pre>@app.route('/', defaults={'path': ''})
@app.route('/&lt;path:path&gt;')
def vue_client(path):
    logging.info(path)
    # return render_template('index.html')
    if os.getenv('GAE_ENV', '').startswith('standard') or not isDuggingVue:
        return render_template('index.html')
    else:
        url = 'http://localhost:3000/{0}'.format(path)
        logging.error(url)
        return redirect(url, code=302)</pre>
      We adapted this configuration from this <a href='https://github.com/Valmoz/gae-vue-flask-starter' target="_blank">
      template</a>. When you are debugging the front-end, this function will redirect to
       http://localhost:3000 where vue app is serving. Otherwise, it will render the <code>index.html</code>
        in your <code>dist</code> folder</li>

          <li>Run your flask+Vue.js app locally. You need to open two terminal windows, one for
            serving the back-end and one for serving the front end.
            <ul>
              <li>For the back-end, run it in a python3 virtual environment(check Running a
              hello-world app part above) and from your app engine folder:
                <pre>python3 main.py</pre>
                The back end will be serving at <a href="http://localhost:8080" target="_blank">http://localhost:8080</a>
                </li>
                <li>For the front-end, in another terminal window, navigate to the
                <code>client</code> folder:
                <pre>npm run serve</pre>
                The front end will be serving at <a href="http://localhost:3000" target="_blank">http://localhost:3000</a>
                </li>
                <li>Type <a href="http://localhost:8080" target="_blank">http://localhost:8080</a>
                in your browser, it will redirect to <a href="http://localhost:3000" target="_blank">http://localhost:3000</a>
                so you will see a vue welcome page.
                </li>
            </ul>
          </li>
          <li>We recommended you to check out this good <a href='https://testdriven.io/blog/developing-a-single-page-app-with-flask-and-vuejs/' target="_blank">
          turtorial</a> of connecting flask and vue.</li>
          <li>Deploy the flask+vue app:
            <ul>
              <li> From the client folder, run this line to build vue front end:
                <pre> npm run build</pre>
              </li>
              <li>From the app folder, run this line to deploy the app to google cloud:
                <pre>gcloud app deploy</pre>
                </li>
            </ul>
          </li>
        </ul>
        </li>
      </ul>
  </div>
  </div>-->
  </div>
</div>
</template>

<script>

export default {
  name: 'Overview',
  data() {
    return {
    };
  },
};
</script>
